import { render, staticRenderFns } from "./move_work_item_modal.vue.js?vue&type=template&id=1f10bad4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./move_work_item_modal.vue?vue&type=template&id=1f10bad4&vue3"
import script from "./move_work_item_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./move_work_item_modal.vue?vue&type=script&lang=js&vue3"
export * from "./move_work_item_modal.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./move_work_item_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports